module.exports = __webpack_public_path__ + "img/promo-1.75f7ab18.png";